var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[(!_vm.loading && _vm.type === 'chat')?_c('ChatEscalation'):_vm._e(),(!_vm.loading && _vm.type === 'ticket')?_c('TicketEscalation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }